import { freddyTheme as theme } from '@coolblue-development/freddy';
import { keyframes } from '@emotion/react';
export const getHeaderDropdownButtonStyles = (isOpen) => ({
    color: isOpen ? theme.color.font.interactiveBase : theme.color.font.inverseBase,
    display: 'inline-flex',
    gap: theme.spacing[200],
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    background: isOpen ? theme.color.background.base : 'var(--cb-button-color-background)',
    border: 0,
    borderRadius: isOpen
        ? `${theme.borderRadius[100]} ${theme.borderRadius[100]} 0 0`
        : theme.borderRadius[100],
    boxShadow: isOpen ? '0 0 5px rgba(20 20 20 / 40%)' : 'var(--cb-button-box-shadow)',
    fontWeight: theme.typography.fontWeight.openSans.bold,
    fontSize: theme.typography.fontSize['xl'],
    fontFamily: 'inherit',
    height: '3.8rem',
    padding: `0 ${theme.spacing[200]}`,
    textTransform: 'none',
    cursor: 'pointer',
    position: 'relative',
    '&::after': {
        content: `""`,
        position: 'absolute',
        top: '99%',
        width: '100%',
        height: '0.9rem',
        background: theme.color.background.base,
        opacity: isOpen ? theme.opacity.full : theme.opacity.transparent,
        zIndex: 7,
        left: 0,
    },
    ...(!isOpen && {
        '&:hover': {
            background: theme.color.background.interactiveInverseHovered,
        },
    }),
    '& > svg': {
        fill: 'currentColor',
        width: '1.2rem',
        height: '1.2rem',
    },
});
const DropdownContentAnimation = keyframes `
  0% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
`;
export const getHeaderDropdownContentStyles = (placement, variant) => {
    const getPlacementProps = () => {
        if (placement === 'left') {
            return { left: 0, transformOrigin: 'top left' };
        }
        if (placement === 'right') {
            return { right: 0, transformOrigin: 'top right' };
        }
        const transformOrigin = 'left' in placement ? 'top left' : 'top right';
        return { ...placement, transformOrigin };
    };
    const getVariantProps = () => {
        if (variant === 'unstyled')
            return {};
        return {
            background: theme.color.background.base,
            borderRadius: `0 0 ${theme.borderRadius[100]} ${theme.borderRadius[100]}`,
            boxShadow: '0 1px 5px rgba(50 50 50 / 60%)',
            padding: theme.spacing[400],
            ...(variant && {
                minWidth: variant === 'wide' ? '30rem' : '22rem',
            }),
        };
    };
    return {
        animation: `${DropdownContentAnimation} 250ms cubic-bezier(0.1, 1.45, 0.35, 1)`,
        marginTop: '0.3rem',
        [theme.breakpoint.minWidth('md')]: {
            marginTop: '0.7rem',
        },
        top: '100%',
        position: 'absolute',
        maxHeight: 'calc(100vh - var(--cb-header-height))',
        ...getVariantProps(),
        ...getPlacementProps(),
    };
};
//# sourceMappingURL=HeaderDropdown.styles.js.map